{
    "client": "Client",
    "description": "Description",
    "createdBy": "Created By",
    "createdOn": "Created On",
    "updatedBy": "Updated By",
    "updatedOn": "Updated On",
    "nextClient": "Next Client",
    "switchClient": "Switch Client",
    "launchNewTab": "Launch in New Tab",
    "arrowright": "arrow_right",
    "launch": "Launch",
    "dataSources": "Data Sources",
    "longName": "Long Name",
    "checkingClientDeletion": "Would you like to delete the selected client?",
    "checkingClientSave": "Would you like to save this client?",
    "pleaseFixValidationErrors": "Please fix the validation errors before saving.",
    "invalidClientName": "Client name must be alphanumeric and cannot contain spaces or special characters.",
    "clientNameTooLong": "Client name cannot exceed 100 characters.",
    "descriptionTooLong": "Description cannot exceed 500 characters.",
    "emptyField": "This field cannot be empty.",
    "clientSavedSuccessfully": "Client saved successfully",
    "clientDeleted": "Client deleted successfully",
    "deletingClient": "Deleting Client",
    "clientDeletionMessage": "Removing client and related records...",
    "clientDeletionFailed": "Failed to delete client"
}